import PropTypes from 'prop-types';

// Estilos
import estilos from './goBack.module.css';
import { GO_BACK, PAGES } from '../../../utils/varGlobal';

function GoBack(props){
    return (
    props.enabled ?
        <a className={estilos.goBack} href={PAGES.MAIN}>{GO_BACK}</a> : 
        <div className={estilos.goBack}></div>
    );
}

GoBack.propTypes = {
    enabled : PropTypes.bool
}

export default GoBack;